import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Zone } from './Zone';

const adjs = ['Beautiful', 'Cool', 'Crazy', 'Dazzling', 'Fabulous', 'Gorgeous', 'Spicy', 'Swanky', 'Tremendous'];

const settingMap = {
    color: 'autoColor',
    border: 'border',
    headingOffset: 'headingOffset',
    headingPosition: 'headingPosition',
    headingStyle: 'headingStyle',
    titleColor: 'titleFontColor',
};

class CreateZoneToolBehavior extends CreatePhysicalToolBehavior2(Zone, 'drag') {

    protected createSubject(u: ObjectUpdate) {
        const zone = super.createSubject(u);
        for (const [l, r] of Object.entries(settingMap)) {
            if (this.settings[l]) zone.set(r, this.settings[l]);
        }
        zone.title = adjs[Math.floor(Math.random() * adjs.length)] + ' New Zone';
        zone.width = this.settings.width ?? 1080;
        zone.height = this.settings.height ?? 720;
        return zone;
    }
}

export const zoneTool = defineToolWithCommonBehaviors({
    id: 'zoneTool',
    label: 'Zones',
    category: 'design',
    icon: 'deqo://icons/d2/zone',
    weight: 3040,
    shortcut: 'Z',
    behaviors: [
        CreateZoneToolBehavior,
    ]
});

